"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import { AuthorImagesPlaceholder } from "@/components/ArticleContent/components/Byline/components/AuthorImages/AuthorImagesPlaceholder.component";
import { BylineImage } from "@/components/ArticleContent/components/Byline/components/BylineImage/BylineImage.component";
import { useAuthorHover } from "@/components/ArticleContent/components/Byline/context/byline-context";
import { EmailLink } from "@/components/Link/EmailLink/EmailLink.component";
import type { ArticleContentModel } from "@/services/api/content/models/article-content-model.types";
type BylineAuthorImageProps = {
  readonly author: ArticleContentModel.Author;
  readonly authorIndex?: number;
  readonly isHovered?: boolean;
};
export function BylineAuthorImage(t0) {
  const $ = _c(13);
  const {
    author,
    isHovered: t1,
    authorIndex
  } = t0;
  const isHovered = t1 === undefined ? false : t1;
  const {
    handleMouseEnter,
    handleMouseLeave
  } = useAuthorHover();
  const hasImage = author.imageUrl !== null;
  const hasEmail = author.email !== null;
  let t2;
  if ($[0] !== author.fullName || $[1] !== author.imageUrl || $[2] !== hasImage || $[3] !== isHovered) {
    t2 = hasImage ? <BylineImage className={clsx("ring-1 ring-white", isHovered ? "scale-105 transition-transform duration-300 ease-out" : "")} fullName={author.fullName} url={author.imageUrl} /> : <AuthorImagesPlaceholder fullName={author.fullName} />;
    $[0] = author.fullName;
    $[1] = author.imageUrl;
    $[2] = hasImage;
    $[3] = isHovered;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const imageComponent = t2;
  if (hasEmail) {
    let t3;
    if ($[5] !== authorIndex || $[6] !== handleMouseEnter) {
      t3 = () => handleMouseEnter(authorIndex ?? 0);
      $[5] = authorIndex;
      $[6] = handleMouseEnter;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== author.email || $[9] !== handleMouseLeave || $[10] !== imageComponent || $[11] !== t3) {
      t4 = <EmailLink className="relative block size-full" emailAddress={author.email} onMouseEnter={t3} onMouseLeave={handleMouseLeave} position="bl-mto-img">{imageComponent}</EmailLink>;
      $[8] = author.email;
      $[9] = handleMouseLeave;
      $[10] = imageComponent;
      $[11] = t3;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  return imageComponent;
}